<template>
  <router-link :to="'portfolio/detail/'+ id" target="_blank" rel="noopener">
    <div class="card_bg ani_up">
      <img class="main_image" :src="image" />
      <div class="card_content">
        <div
          style="
            font-weight: 700;
            color: black;
            display: block;
            font-size: 18px;
          "
        >
          {{ text1 }}
        </div>
        <div
          style="
            font-weight: 500;
            color: #777777;
            display: block;
            font-size: 16px;
          "
        >
          {{ text2 }}
        </div>
        <div>
          <div v-if="tags.length" class="tags">
            <span
              v-for="(tag, idx) in tags"
              :key="idx + '-' + tag"
              class="tag"
            >
              #{{ tag }}
            </span>
          </div>
          <div class="start_date">
            {{ formattedText4 }}
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>
    
    <script>
export default {
  props: ["record", "id", "image", "text1", "text2", "text3", "link", "tag_list", "start_date"],
  data() {
    return {};
  },
  computed: {
    isDesktop() {
      if (typeof navigator === "undefined") {
        return true;
      }
      return !/Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(
        navigator.userAgent
      );
    },
    formattedText3: function () {
      return this.text3.replace(/\n/g, "<br>");
    },
    formattedText4: function () {
      if(this.start_date)
        return this.start_date.substring(0, 4) + '. ' + this.start_date.substring(4, 6) + '. ' + this.start_date.substring(6, 8) + ' 출시' 
      else
        return ''
    },
    tags() {
      let r = this.tag_list?.map(m=>m.tag) || []
      return r;
    },
  },
};
</script>
    
  <style scoped>
.bg {
  display: flex;
  justify-content: center;
  text-align: center;
}
.caption {
  width: fit-content;
  position: relative;
  padding-left: 10px;
  padding-right: 10px;
}
.card_bg {
  padding: 0px;
  text-align: left;
  width: 352px;
  height: 355px;
  background: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  overflow: hidden;
}

.card_content {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 40px;
  overflow: hidden;
}

.main_image {
  width: 100%;
  height: 190px;
  object-fit: cover;
  border-top-left-radius: 16px;
}

@media screen and (max-width: 1440px) {
  .card_bg {
    padding: 0px;
    text-align: left;
    width: 90vw;
    background: #ffffff;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05);
    border-radius: 16px;
    overflow: hidden;
  }

}

.tags {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  align-items: center;
  height: 100%;
}

.tag {
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  background-color: #f1f3f5;
  color: #495057;
  border-radius: 9999px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
  white-space: nowrap;
}

.start_date {
  font-weight: 400;
  color: #777777;
  display: block;
  font-size: 14px;
  margin-top: 12px;
}

</style>